import { FC } from 'react';
import {
  BreadcrumbItem,
  BreadcrumbLink,
  Breadcrumb as ChakraBreadcrumb,
  Text,
} from '@chakra-ui/react';
import { BiChevronRight } from 'react-icons/bi';
import { Link } from 'react-router-dom';

import { BreadcrumbFragment } from '../../graphql/generated';
import { navigateToDirectory } from '../../pages/file-browser-page/file-browser-page';

type BreadcrumbsProps = {
  cedantId: string; // cedant id from the URL params
  breadcrumbs: BreadcrumbFragment[];
};

export const Breadcrumbs: FC<BreadcrumbsProps> = ({
  cedantId,
  breadcrumbs,
}) => {
  return (
    <ChakraBreadcrumb
      mb="8"
      spacing="2"
      separator={<BiChevronRight size={28} />}
      data-testid="breadcrumb-controller"
    >
      {breadcrumbs.map((crumb, index) => {
        const finalCrumb = index === breadcrumbs.length - 1;
        const uniqueKey = crumb.directoryId || `root-${crumb.name}`;

        return (
          <BreadcrumbItem
            color="gray.500"
            data-testid="crumb"
            key={uniqueKey}
            _first={{ textTransform: 'capitalize' }}
          >
            {finalCrumb ? (
              <Text
                color="gray.900"
                data-testid="active"
                textStyle="breadcrumb"
              >
                {crumb.name}
              </Text>
            ) : (
              <BreadcrumbLink
                as={Link}
                to={navigateToDirectory({
                  cedantId,
                  directoryId: crumb.directoryId || undefined,
                })}
              >
                <Text textStyle="breadcrumb">{crumb.name}</Text>
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>
        );
      })}
    </ChakraBreadcrumb>
  );
};
